export const ordenaPor = [
  { Codigo: "Codigo", Nome: "Código" },
  { Codigo: "Nome", Nome: "Nome" },
  { Codigo: "Admissao", Nome: "Data de Admissão" },
  { Codigo: "Salario", Nome: "Salário", fn: o => parseFloat(o.Salario) },
  { Codigo: "DataNascimento", Nome: "Data de Nascimento" },
  { Codigo: "VencimentoFerias", Nome: "Vencimento Férias" },
]
